// Header language switcher (i18n S4.3).
//
// Flips both layers of localisation at once: UI strings (via i18next) and
// content names (via the X-Locale header — setLocale() dispatches the event
// that makes react-query refetch).  The chosen locale persists in
// localStorage so it survives reloads.

import { useTranslation } from "react-i18next";

import { UI_LOCALES, getLocale, setLocale, type UiLocale } from "@/lib/i18n";

const LABELS: Record<UiLocale, string> = {
  ru: "RU",
  en: "EN",
};

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  // i18n.language keeps the component re-rendering on change; fall back to the
  // stored value for the very first paint.
  const current = (i18n.language || getLocale()).split("-")[0];

  return (
    <label className="flex items-center" title={t("nav.language")}>
      <span className="sr-only">{t("nav.language")}</span>
      <select
        value={UI_LOCALES.includes(current as UiLocale) ? current : UI_LOCALES[0]}
        onChange={(e) => setLocale(e.target.value)}
        aria-label={t("nav.language")}
        className="px-2 py-1.5 rounded-md text-xs font-mono uppercase tracking-wider bg-transparent text-text-secondary hover:text-text-primary hover:bg-surface-hover transition-colors border border-transparent focus:border-border focus:outline-none cursor-pointer"
      >
        {UI_LOCALES.map((l) => (
          <option key={l} value={l}>
            {LABELS[l]}
          </option>
        ))}
      </select>
    </label>
  );
}
